export default __webpack_public_path__ + "static/media/i_bus-gen_gn.0d0072fd.svg";